/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentMethodOverridableConfiguration } from './PaymentMethodOverridableConfiguration';
import {
    PaymentMethodOverridableConfigurationFromJSON,
    PaymentMethodOverridableConfigurationFromJSONTyped,
    PaymentMethodOverridableConfigurationToJSON,
    PaymentMethodOverridableConfigurationToJSONTyped,
} from './PaymentMethodOverridableConfiguration';

/**
 * 
 * @export
 * @interface CreatePaymentMethodLocationConnectionRequest
 */
export interface CreatePaymentMethodLocationConnectionRequest {
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentMethodLocationConnectionRequest
     */
    locationId: number;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof CreatePaymentMethodLocationConnectionRequest
     */
    enabledInApps?: Set<FavritApp> | null;
    /**
     * 
     * @type {PaymentMethodOverridableConfiguration}
     * @memberof CreatePaymentMethodLocationConnectionRequest
     */
    overridableConfiguration?: PaymentMethodOverridableConfiguration | null;
}

/**
 * Check if a given object implements the CreatePaymentMethodLocationConnectionRequest interface.
 */
export function instanceOfCreatePaymentMethodLocationConnectionRequest(value: object): value is CreatePaymentMethodLocationConnectionRequest {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodLocationConnectionRequestFromJSON(json: any): CreatePaymentMethodLocationConnectionRequest {
    return CreatePaymentMethodLocationConnectionRequestFromJSONTyped(json, false);
}

export function CreatePaymentMethodLocationConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodLocationConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'enabledInApps': json['enabledInApps'] === undefined ? undefined : json['enabledInApps'] === null ? null : (new Set((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'overridableConfiguration': json['overridableConfiguration'] === undefined ? undefined : json['overridableConfiguration'] === null ? null : PaymentMethodOverridableConfigurationFromJSON(json['overridableConfiguration']),
    };
}

export function CreatePaymentMethodLocationConnectionRequestToJSON(json: any): CreatePaymentMethodLocationConnectionRequest {
    return CreatePaymentMethodLocationConnectionRequestToJSONTyped(json, false);
}

export function CreatePaymentMethodLocationConnectionRequestToJSONTyped(value?: CreatePaymentMethodLocationConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'enabledInApps': value['enabledInApps'] == null ? undefined : (Array.from(value['enabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'overridableConfiguration': PaymentMethodOverridableConfigurationToJSON(value['overridableConfiguration']),
    };
}

